import { render, staticRenderFns } from "./UploadAttachment.vue?vue&type=template&id=5a79ff3b&scoped=true"
import script from "./UploadAttachment.vue?vue&type=script&lang=js"
export * from "./UploadAttachment.vue?vue&type=script&lang=js"
import style0 from "./UploadAttachment.vue?vue&type=style&index=0&id=5a79ff3b&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a79ff3b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pagsmile/front-end/pagsmile-dashboard/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a79ff3b')) {
      api.createRecord('5a79ff3b', component.options)
    } else {
      api.reload('5a79ff3b', component.options)
    }
    module.hot.accept("./UploadAttachment.vue?vue&type=template&id=5a79ff3b&scoped=true", function () {
      api.rerender('5a79ff3b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/MerchantKYC/components/UploadAttachment.vue"
export default component.exports